import { api } from '../../../plugins/axios';

export class Option {
	values = undefined;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	static async getList(params) {
		const res = await api.get('/resources/options', { params });
		const data = res.data.result.options.data.map((product) => new Option(product));
		const totalRecords = res.data.result.options.total;

		return {
			data,
			totalRecords,
		};
	}

	static async getById(id) {
		const res = await api.get(`/resources/option-details`, {
			params: {
				id,
			},
		});
		return new Option(res.data);
	}

	async getValues() {
		if (this.values) return this.values;
		const data = await Option.getById(this.id);
		Object.assign(this, data);
		return this.values;
	}
}
